import { gql } from '@apollo/client'

export default gql(`
query listUserAntiPiracyActions( $userId: String $project: String  ) {
    listUserAntiPiracyActions( 
      userId: $userId
      project: $project
    ) {
      statusCode
      data {
        email
        operatorNote
        createdAt
        actionDetails {
          action
          subActions {
            subAction
          }
        }
        email
        
      }
    }
}`)
